<template>
  <div class="banner" :style="bannerStyle" v-show="imgInfo.url">
    <div class="m-banner-list"><img :src="imgInfo.url" /></div>
  </div>
</template>

<script>
export default {
  props: {
    imgUrl: {
      type: String,
      default: null
    },
    domain: {
      type: String,
      default: null
    }
  },
  components: {},
  watch: {
    domain: {
      handler(v) {
        console.log("domian", v);
        this.handlerGetImg();
      },
      immediate: true
    }
  },
  name: "banner",
  data() {
    return {
      bannerStyle: {},
      imgInfo: {}
    };
  },
  mounted() {},
  methods: {
    // 设置图片
    initDefImg() {
      this.url = this.imgInfo.url || this.imgUrl;
      if (this.imgInfo.bgurl) {
        this.bannerStyle = {
          "background-image": `url(${this.imgInfo.bgurl})`,
          "min-height": "319px",
          width: "1920px"
        };
      }
    },
    // 查询广告图
    async handlerGetAdviceBanner() {
      // 查询up设置的联盟网校页图
      const { data = [] } = await this.$api.handlerGetAdvBanner({
        domain: this.domain,
        seatIdstr: "59_60",
        channel: 1
      });
      // 主图
      let mtArr = data.filter((item) => item.seatId == 59)[0];
      let url = mtArr?.image || mtArr?.picture;
      // 背景图
      let bgArr = data.filter((item) => item.seatId == 60)[0];
      let bgurl = bgArr?.picture || bgArr?.image;
      this.imgInfo = {
        url,
        bgurl
      };
    },
    // 查询联盟设置的推广图
    async handlergetLmSiteBanner() {
      const { data } = await this.$api.getLmSiteBanner({
        domain: this.domain
      });
      let url = data.bannerImg
      if(url) {
        this.imgInfo = {
          url
        }
        throw new Error('后台已设置图片')
      }
    },
    async handlerGetImg() {
      try {
        await this.handlergetLmSiteBanner();
        await this.handlerGetAdviceBanner();
      } catch (err) {
        console.log(err);
      } finally {
        this.initDefImg();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  background: transparent;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  min-height: 300px;
  max-width: 1920px;
  width: 100%;
  overflow: hidden;
  .m-banner-list {
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    margin-left: 0;
    transform: translateX(-50%);
  }
}
</style>
